import * as agency from './agency';
import { Resources } from './resource';
// import * as transaction from './transaction';
// import * as user from './user';
import * as users from './users';
import * as userInfo from './user-info';
import * as roles from './roles';
import * as groups from './groups';
import * as userRole from './user-role';
import * as dashboardV2 from './dashboard-v2';
import * as dashboardV3 from './dashboard-v3';
import * as tokenMetadata from './token/metadatas';
import * as tokenOnchainInfo from './token/onchain-infos';
import * as systemRpc from './system-rpc';
import * as systemProxy from './system-proxy';
import * as crawlerMonitor from './crawler-monitor';
import * as cronMonitor from './cron-monitor';
import * as categories from './home/categories';
import * as smartMoney from './smart-money';
import * as xStock from './token/x-stocks';
import * as feeManagement from './trading/fee-management';
import * as trandingToken from './configs/tranding-tokens';
import * as searchPlaceholder from './configs/search-placeholders';
import * as color from './configs/colors';
import * as transactions from './transactions';
import * as adminConfig from './configs/admin-configs';
import * as transactionDashboard from './swap-transactions/dashboard';
import * as routingStatistics from './swap-transactions/routing-statistics';
import * as tokenRouteStatistics from './swap-transactions/token-route-statistics';
import * as swapUserRanking from './swap-users/ranking';
import * as swapUserDetail from './swap-users/detail';
import * as swapChainsManagement from './swap-chain-token/chains-management';
import * as swapTokensManagement from './swap-chain-token/tokens-management';
import * as swapConfigFee from './swap-config/fee';
import * as swapConfigRango from './swap-config/rango';
import * as activityTasks from './activity/tasks';
import * as activityUsers from './activity/users';
import * as activityUserCashbackDashboard from './activity/userCashbackDashboard';
import * as activityUserActivityCashbackSummary from './activity/userActivityCashbackSummary';
import * as activityUsertaskCenter from './activity/usertaskCenter';
import * as activityUserTaskCompletionHistory from './activity/userTaskCompletionHistory';
import * as activityTaskCompletionStats from './activity/taskCompletionStats';
import * as activityTaskCategories from './activity/categories';
import * as activityTierBenefits from './activity/tierBenefits';
import * as activityTierBenefitDistribution from './activity/tierBenefitDistribution';
import * as activityUserActivityStats from './activity/userActivityStats';
import * as agents from './agents';
import * as unlimitedAgents from './unlimited-agents';
import * as rewardsOverview from './rewards-overview';
import * as rewardsTask from './rewards-task';
import * as agentInfo from './agent-info';
import * as sign from './finance/sign';
import * as withdraw from './finance/withdraw';
import * as financeTransfers from './finance/transfers';
import * as financeAllowlist from './finance/allowlist';
import * as financeLimits from './finance/limits';
import * as tunkeySetup from './finance/turnkey-config';
import * as maintenance from './maintenance';
import * as inviteCodes from './invite-codes';
import * as inviteBetaCodeConfig from './invite-beta-code-config';
import * as banners from './banners';
import * as smallBanners from './small-banners';
import * as hotSearch from './hot-search';
import * as hotSymbols from './hot-symbols';
import * as relayDeposit from './relay-deposit';
import * as auditLogs from './audit-logs';
import * as userFeedback from './user-feedback';
import * as analytics from './analytics';
import * as appVersionManagement from './app-version-management';
import * as domainConfigs from './domain-configs';
import * as healthCheckProxy from './domain-configs/health-check-proxy';
import * as announcementPopup from './new-announcement-popup';
import * as linkConfig from './publishing/link-configs';
import * as cdnUpload from './publishing/cdn-uploads';
import * as coinImages from './publishing/coin-images';
import * as coinSymbols from './publishing/coin-symbols';
import * as redpacketTypeConfig from './redpacket/type-config';
import * as redpacketOverview from './redpacket/overview';
import * as redpacketIntervention from './redpacket/intervention';
import * as redpacketConfig from './redpacket/redPacket-config';
import * as redpacketRecords from './redpacket/records';
import * as redpacketLottoDrawConfigs from './redpacket/lotto-draw-configs';
import * as redpacketDesignatedRedPackets from './redpacket/designated-redpackets';
import * as redpacketLeaderboardCycles from './redpacket/leaderboard-cycles';
import * as redpacketDailyPrizePool from './redpacket/daily-prize-pool';
import * as redpacketDailyPrizePoolStatus from './redpacket/daily-prize-pool-status';
import * as redpacketDailyPrizePoolConfigAudit from './redpacket/daily-prize-pool-config-audit';
import * as redpacketFeatureFlags from './redpacket/feature-flags';
import * as redpacketCampaignDates from './redpacket/campaign-dates';
import * as redpacketRewardPoolBalances from './redpacket/reward-pool-balances';
import * as redpacketOverlay from './redpacket/overlay';
import * as referralRanking from './referral-ranking';
import * as tradingRetention from './trading-retention';
import * as redpacketLuckyLottoHistory from './redpacket/lucky-lotto-history';
import * as blindBoxOverview from './blind-box/overview';
import * as blindBoxActivityBasic from './blind-box/activity-basic';
import * as blindBoxLuckyWheel from './blind-box/lucky-wheel';
import * as blindBoxBlindBoxProbability from './blind-box/blind-box-probability';
import * as blindBoxTradingTiers from './blind-box/trading-tiers';
import * as blindBoxManualDistribution from './blind-box/manual-distribution';
import * as blindBoxLeaderboard from './blind-box/leaderboard';
import * as blindBoxLevelSystem from './blind-box/level-system';
import * as blindBoxLevelProbabilities from './blind-box/level-probabilities';
import * as blindBoxHolidayLottery from './blind-box/holiday-lottery';
import * as blindBoxHolidayLotteryConfig from './blind-box/holiday-lottery-config';
import * as blindBoxTasks from './blind-box/tasks';
import * as blindBoxWinnersTicker from './blind-box/winners-ticker';
import * as blindBoxWinRecords from './blind-box/win-records';
import * as blindBoxOpenSessions from './blind-box/open-sessions';
import * as blindBoxTaskClaims from './blind-box/task-claims';
import * as blindBoxLotteryTickets from './blind-box/lottery-tickets';
import * as blindBoxUserXpHistory from './blind-box/user-xp-history';
import * as blindBoxSpinBoxGrantHistory from './blind-box/spin-box-grant-history';
import * as blindBoxUserRewardSummary from './blind-box/user-reward-summary';
import * as blindBoxRewardFeed from './blind-box/reward-feed';
import * as blindBoxRewardFeedUsdc from './blind-box/reward-feed-usdc';
import * as blindBoxSocialFollowers from './blind-box/social-followers';
import * as blindBoxWithdrawConfig from './blind-box/withdraw-config';
import * as blindBoxWithdrawals from './blind-box/withdrawals';
import * as blindBoxBannedUsers from './blind-box/banned-users';
import * as socialTradingWorkbench from './social-trading/workbench';
import * as socialTradingAccounts from './social-trading/accounts';
import * as socialTradingUsers from './social-trading/users';
import * as socialTradingAgents from './social-trading/agents';
import * as socialTradingRooms from './social-trading/rooms';
import * as socialTradingRoomMembers from './social-trading/room-members';
import * as socialTradingSignals from './social-trading/signals';
import * as socialTradingIntel from './social-trading/intel';
import * as socialTradingIntelCategories from './social-trading/intel-categories';
import * as socialTradingRedpacketLedger from './social-trading/redpacket-ledger';
import * as socialTradingRedpacketConfig from './social-trading/redpacket-config';
import * as socialTradingRedpacketPackets from './social-trading/redpacket-packets';
import * as socialTradingRedpacketLedgerEntries from './social-trading/redpacket-ledger-entries';
import * as socialTradingRedpacketWithdrawals from './social-trading/redpacket-withdrawals';
import * as socialTradingRedpacketBalanceReclaim from './social-trading/redpacket-balance-reclaim';
import * as socialTradingRedpacketPlatformLedger from './social-trading/redpacket-platform-ledger';
import * as socialTradingSystemConfigs from './social-trading/system-configs';
import * as socialTradingAvatarDefaults from './social-trading/avatar-defaults';
import * as socialTradingRedpacketDisplayRules from './social-trading/redpacket-display-rules';
import * as socialTradingPoolConfig from './social-trading/pool-config';
import * as socialTradingAgentsConfig from './social-trading/agents-config';
import * as socialTradingPools from './social-trading/pools';
import * as socialTradingPoolDashboard from './social-trading/pool-dashboard';
import * as socialTradingPoolEnrollments from './social-trading/pool-enrollments';
import * as socialTradingPoolContributions from './social-trading/pool-contributions';
import * as socialTradingPoolRewardClaims from './social-trading/pool-reward-claims';
import * as socialTradingMessageStats from './social-trading/message-stats';
import * as socialTradingAudit from './social-trading/audit';
import * as rewardClaims from './agent-rebate/reward-claims';
import * as xbitRelayHotWallets from './xbit-relay/hot-wallets';
import * as xbitRelayDeposits from './xbit-relay/deposits';
import * as xbitRelayWithdrawals from './xbit-relay/withdrawals';
import * as xbitRelayTransfers from './xbit-relay/transfers';
import * as xbitRelaySweepMonitor from './xbit-relay/sweep-monitor';
import * as xbitRelaySweepHistory from './xbit-relay/sweep-history';
import * as xbitRelayDepositWallets from './xbit-relay/deposit-wallets';
import * as xbitRelayWithdrawalProviderConfigs from './xbit-relay/withdrawal-provider-configs';
import * as xbitRelayTransactionRescan from './xbit-relay/transaction-rescan';
import * as xbitRelayHotWalletBalancer from './xbit-relay/hot-wallet-balancer';
import * as xbitRelayProviderAudit from './xbit-relay/provider-audit';
import * as predictionConfigs from './prediction/configs';
import * as predictionFeaturedMarkets from './prediction/featured-markets';
import * as xpxPerpsWithdrawal from './xpx-perps-withdrawal';
import * as xpxPerpsChainConfigs from './xpx-perps-chain-token-config/chain-configs';
import * as xpxPerpsTokenConfigs from './xpx-perps-chain-token-config/token-configs';
import * as perpsV1Views from './perps-v1-views';
import * as perpsV1Pins from './perps-v1-pins';
import * as perpsV1Sectors from './perps-v1-sectors';
import * as perpsV1Symbols from './perps-v1-symbols';
import * as perpsV1Presets from './perps-v1-presets';
import * as predictionTrading from './prediction-trading';
import * as perpetualTrading from './perpetual-trading';
import * as agentRewardRules from './agent-reward-rules';
import * as worldCupOverview from './world-cup/overview';
import * as worldCupMatchData from './world-cup/match-data';
import * as worldCupFocusMatchConfig from './world-cup/focus-match-config';
import * as worldCupGrandPrixConfig from './world-cup/grand-prix-config';
import * as worldCupLeaderboardConfig from './world-cup/leaderboard-config';
import * as worldCupPredictionVoucherRule from './world-cup/prediction-voucher-rule';
import * as worldCupEmergencyFuse from './world-cup/emergency-fuse';
import * as worldCupFaq from './world-cup/faq';
import * as worldCupManualIssue from './world-cup/manual-issue';
import * as worldCupUserVouchers from './world-cup/user-vouchers';
import * as worldCupWhitelist from './world-cup/whitelist';
import * as worldCupBreakingEvents from './world-cup/breaking-events-config';
import * as whitelistCandidate from './whitelist/configs';
import * as whitelistReward from './whitelist/reward';
import * as whitelistFaq from './whitelist/faq';
import * as whitelistEarlyBird from './whitelist/early-bird';
import * as whiteListLeaderboard from './whitelist/leaderboard';
import * as whitelistInvite from './whitelist/invite';
import * as whitelistManually from './whitelist/manually';
import * as whitelistRedeem from './whitelist/redeem';
import * as whitelistUsers from './whitelist/users';
import * as whitelistEventParticipants from './whitelist/event-participants';
import * as turnkeyAddressSearch from './turnkey-address-search';
import * as proxyManager from './proxy-manager';
import * as proxyManagerProxies from './proxy-manager/proxies';
import * as proxyManagerPools from './proxy-manager/pools';
import * as proxyManagerProxyScores from './proxy-manager/proxy-score';
import * as boldPredictionCampaign from './bold-prediction-campaign';
import * as boldPredictionCampaignStatistics from './bold-prediction-campaign/statistics';
import * as notificationConfigs from './notification-configs';
import * as notificationConfigsTemplates from './notification-configs/templates';
import * as notificationConfigsRecords from './notification-configs/records';
import * as vaultParams from './vault/params';
import * as vaultOfficialVaults from './vault/official-vaults';
import * as vaultVaults from './vault/vaults';
import * as vaultDashboard from './vault/dashboard';
import * as vaultInvestors from './vault/investors';
import * as vaultRecords from './vault/records';
import * as vaultReconciliation from './vault/reconciliation';
import * as vaultOperations from './vault/operations';


const addionalResources = [Resources.userStatistics].map((name) => ({
  name,
}));

export default [
  dashboardV2,
  dashboardV3,
  agency,
  users,
  userInfo,
  roles,
  groups,
  userRole,
  tokenMetadata,
  tokenOnchainInfo,
  systemRpc,
  systemProxy,
  crawlerMonitor,
  cronMonitor,
  categories,
  smartMoney,
  xStock,
  feeManagement,
  trandingToken,
  searchPlaceholder,
  color,
  transactions,
  adminConfig,
  transactionDashboard,
  routingStatistics,
  tokenRouteStatistics,
  swapUserRanking,
  swapUserDetail,
  swapChainsManagement,
  swapTokensManagement,
  swapConfigFee,
  swapConfigRango,
  activityTasks,
  activityUsers,
  activityUserCashbackDashboard,
  activityUserActivityCashbackSummary,
  activityUsertaskCenter,
  activityUserTaskCompletionHistory,
  activityTaskCompletionStats,
  activityTaskCategories,
  activityTierBenefits,
  activityTierBenefitDistribution,
  activityUserActivityStats,
  agents,
  unlimitedAgents,
  rewardsOverview,
  rewardsTask,
  agentInfo,
  sign,
  withdraw,
  financeTransfers,
  financeAllowlist,
  financeLimits,
  tunkeySetup,
  maintenance,
  sign,
  withdraw,
  tunkeySetup,
  inviteCodes,
  inviteBetaCodeConfig,
  banners,
  smallBanners,
  hotSearch,
  hotSymbols,
  relayDeposit,
  auditLogs,
  userFeedback,
  analytics,
  appVersionManagement,
  domainConfigs,
  healthCheckProxy,
  announcementPopup,
  linkConfig,
  cdnUpload,
  coinImages,
  coinSymbols,
  redpacketTypeConfig,
  redpacketOverview,
  redpacketIntervention,
  redpacketConfig,
  redpacketRecords,
  redpacketLottoDrawConfigs,
  redpacketDesignatedRedPackets,
  redpacketLeaderboardCycles,
  redpacketDailyPrizePool,
  redpacketDailyPrizePoolStatus,
  redpacketDailyPrizePoolConfigAudit,
  redpacketFeatureFlags,
  redpacketCampaignDates,
  redpacketRewardPoolBalances,
  redpacketOverlay,
  referralRanking,
  tradingRetention,
  redpacketLuckyLottoHistory,
  blindBoxOverview,
  blindBoxActivityBasic,
  blindBoxLuckyWheel,
  blindBoxBlindBoxProbability,
  blindBoxTradingTiers,
  blindBoxManualDistribution,
  blindBoxLeaderboard,
  blindBoxLevelSystem,
  blindBoxLevelProbabilities,
  blindBoxHolidayLottery,
  blindBoxHolidayLotteryConfig,
  blindBoxTasks,
  blindBoxWinnersTicker,
  blindBoxWinRecords,
  blindBoxOpenSessions,
  blindBoxTaskClaims,
  blindBoxLotteryTickets,
  blindBoxUserXpHistory,
  blindBoxSpinBoxGrantHistory,
  blindBoxUserRewardSummary,
  blindBoxRewardFeed,
  blindBoxRewardFeedUsdc,
  blindBoxSocialFollowers,
  blindBoxWithdrawConfig,
  blindBoxWithdrawals,
  blindBoxBannedUsers,
  socialTradingWorkbench,
  socialTradingAccounts,
  socialTradingUsers,
  socialTradingAgents,
  socialTradingRooms,
  socialTradingRoomMembers,
  socialTradingSignals,
  socialTradingIntel,
  socialTradingIntelCategories,
  socialTradingRedpacketLedger,
  socialTradingRedpacketConfig,
  socialTradingRedpacketPackets,
  socialTradingRedpacketLedgerEntries,
  socialTradingRedpacketWithdrawals,
  socialTradingRedpacketBalanceReclaim,
  socialTradingRedpacketPlatformLedger,
  socialTradingSystemConfigs,
  socialTradingAvatarDefaults,
  socialTradingRedpacketDisplayRules,
  socialTradingPoolConfig,
  socialTradingAgentsConfig,
  socialTradingPools,
  socialTradingPoolDashboard,
  socialTradingPoolEnrollments,
  socialTradingPoolContributions,
  socialTradingPoolRewardClaims,
  socialTradingMessageStats,
  socialTradingAudit,
  rewardClaims,
  predictionConfigs,
  predictionFeaturedMarkets,
  predictionTrading,
  xbitRelayHotWallets,
  xbitRelayDeposits,
  xbitRelayWithdrawals,
  xbitRelayTransfers,
  xbitRelaySweepMonitor,
  xbitRelaySweepHistory,
  xbitRelayDepositWallets,
  xbitRelayWithdrawalProviderConfigs,
  xbitRelayTransactionRescan,
  xbitRelayHotWalletBalancer,
  xbitRelayProviderAudit,
  perpetualTrading,
  agentRewardRules,
  xpxPerpsChainConfigs,
  xpxPerpsTokenConfigs,
  xpxPerpsWithdrawal,
  perpsV1Views,
  perpsV1Pins,
  perpsV1Sectors,
  perpsV1Symbols,
  perpsV1Presets,
  worldCupOverview,
  worldCupMatchData,
  worldCupFocusMatchConfig,
  worldCupGrandPrixConfig,
  worldCupLeaderboardConfig,
  worldCupPredictionVoucherRule,
  worldCupEmergencyFuse,
  worldCupFaq,
  worldCupManualIssue,
  worldCupUserVouchers,
  worldCupWhitelist,
  worldCupBreakingEvents,
  whitelistCandidate,
  whitelistReward,
  whitelistFaq,
  whitelistEarlyBird,
  boldPredictionCampaign,
  boldPredictionCampaignStatistics,
  notificationConfigs,
  notificationConfigsTemplates,
  notificationConfigsRecords,
  whiteListLeaderboard,
  whitelistInvite,
  whitelistManually,
  whitelistRedeem,
  whitelistUsers,
  whitelistEventParticipants,
  turnkeyAddressSearch,
  proxyManager,
  proxyManagerProxies,
  proxyManagerPools,
  proxyManagerProxyScores,
  vaultDashboard,
  vaultParams,
  vaultOfficialVaults,
  vaultVaults,
  vaultInvestors,
  vaultRecords,
  vaultReconciliation,
  vaultOperations,
  ...addionalResources,
];
